import styled from 'styled-components'


function Option({ data, selected, onSelect }) {

  // console.log("options")
  // console.log(data)
  // console.log(data.index)
  // console.log(data.name)

  // const productPrice = data.price > 0 ? data.price : null

  return (
    <OptionItem data-option-name={data.name} selected={selected}
      onClick={onSelect}
    >
      {data.name}
      {/* {productPrice && <p>£{productPrice} </p>} */}
    </OptionItem>
  );
}

export default Option



const OptionItem = styled.div`
  padding: 16px 20px; 
  cursor: pointer;
  display: flex;
  color: var(--text-color);
  text-transform: uppercase;
  justify-content: space-between;
  background: ${({ selected }) => (selected ? "var(--input-bg-hover)" : "var(--input-bg)")};

  &:hover {
    background: var(--input-bg-hover);
  }
`;